import React, { Component } from "react";
import { Table, Button, ButtonGroup, Progress } from "reactstrap";
import { connect } from "react-redux";
import * as actions from "../../actions";
import moment from "moment";
import { DAYS } from "../../constants/staticKeys";
import { ReservationScheduleDayLayout, ZoomComponent } from "./Components";
import { EMPTY_RES_SCHEDULE_JSON } from "../../constants/objectTemplates";
import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";
import { AppSwitch } from "@coreui/react";
import "./ReservationSchedule.css";

class ReservationSchedule extends Component {
  componentDidMount() {
    if (Object.keys(this.props.reservationReducer.reservation).length === 0) {
      this.props.history.push("/home/reservations");
    }
  }

  componentWillUnmount() {
    this.props.updateReservationProps([
      { prop: "reservation", value: {} },
      { prop: "reservationSchedule", value: [] },
    ]);
  }

  addVisitToReservationSchedule = (index, visit) => {
    this.props.addVisitToReservationSchedule(index, visit);
  };

  removeVisitToReservationSchedule = (index, visitIndex) => {
    this.props.removeVisitToReservationSchedule(index, visitIndex);
  };

  applyDrag = (arr, dragResult) => {
    const { removedIndex, addedIndex, payload } = dragResult;
    if (removedIndex === null && addedIndex === null) return arr;

    const result = [...arr];
    let itemToAdd = payload;

    if (removedIndex !== null) {
      itemToAdd = result.splice(removedIndex, 1)[0];
    }

    if (addedIndex !== null) {
      result.splice(addedIndex, 0, itemToAdd);
    }
    return result;
  };

  createNewReservationSchedule = (
    date,
    reservation_id,
    calWeekIndex,
    calDayIndex
  ) => {
    let schedule = JSON.parse(JSON.stringify(EMPTY_RES_SCHEDULE_JSON));
    this.props.createNewReservationSchedule(
      date,
      schedule,
      reservation_id,
      calWeekIndex,
      calDayIndex
    );
  };

  saveReservationSchedule = () => {
    const { reservationSchedule } = this.props.reservationReducer;
    this.props.saveReservationSchedule(reservationSchedule);
  };

  renderDay = (
    reservationSchedule,
    venuesLookup,
    day,
    arrival,
    departure,
    reservation_id,
    calWeekIndex,
    calDayIndex,
    zoom
  ) => {
    const { isOldDaysEnabled, savingReservationSchedule } =
      this.props.reservationReducer;

    let index;
    let result = reservationSchedule.filter((d) => {
      return (
        moment(d.date, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD") ===
        moment(day.date, "YYYY-MM-DD").format("YYYY-MM-DD")
      );
    });

    if (result.length !== 0) {
      result = result[0];
      index = reservationSchedule.findIndex((d) => {
        return (
          moment(d.date, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD") ===
          moment(day.date, "YYYY-MM-DD").format("YYYY-MM-DD")
        );
      });
    } else {
      result = null;
      index = -1;
    }

    return (
      <ReservationScheduleDayLayout
        venuesLookup={venuesLookup}
        schIndex={index}
        schedule={result}
        isWithinTrip={day.isWithinTrip}
        date={day.date}
        applyDrag={this.applyDrag}
        addVisitToReservationSchedule={this.addVisitToReservationSchedule}
        removeVisitToReservationSchedule={this.removeVisitToReservationSchedule}
        deleteReservationProps={this.props.deleteReservationProps}
        updateReservationProps={this.props.updateReservationProps}
        createNewReservationSchedule={this.createNewReservationSchedule}
        reservation_id={reservation_id}
        calWeekIndex={calWeekIndex}
        calDayIndex={calDayIndex}
        isLoading={day.isLoading}
        zoom={zoom}
        isOldDaysEnabled={isOldDaysEnabled}
        savingReservationSchedule={savingReservationSchedule}
      />
    );
  };

  render() {
    const {
      calendar,
      reservation,
      zoom,
      savingReservationSchedule,
      isOldDaysEnabled,
      reservationSchedule,
    } = this.props.reservationReducer;
    const { venuesLookup } = this.props.venuesReducer;
    const venueOptions = venuesLookup && venuesLookup.data ? venuesLookup.data : [];

    let notCovered = [];
    if (reservation.efficiency < 100) {
      venueOptions.forEach((place) => {
        let found = reservationSchedule.some((schedule) => {
          let list = schedule.schedule.visits.filter((visit) => {
            return visit.name === place.name;
          });
          return list.length > 0;
        });

        if (!found) {
          notCovered.push(place);
        }
      });
    }

    return (
      <div className="reservation-schedule-page">
        <div className="reservation-schedule-page__hero">
          <div>
            <div className="reservation-schedule-page__eyebrow">Reservation Flow</div>
            <h1 className="reservation-schedule-page__title">Reservation Schedule</h1>
            <p className="reservation-schedule-page__copy">
              Edit daily visits, tune timings, and review uncovered venues before
              saving the final itinerary.
            </p>
          </div>

          <div className="reservation-schedule-page__stats">
            <div className="reservation-schedule-stat">
              <span className="reservation-schedule-stat__label">Reservation</span>
              <span className="reservation-schedule-stat__value">
                {reservation.reservation_number}
              </span>
            </div>
            <div className="reservation-schedule-stat">
              <span className="reservation-schedule-stat__label">Pax</span>
              <span className="reservation-schedule-stat__value">{reservation.pax}</span>
            </div>
            <div className="reservation-schedule-stat">
              <span className="reservation-schedule-stat__label">Arrival</span>
              <span className="reservation-schedule-stat__value">{reservation.arrival}</span>
            </div>
            <div className="reservation-schedule-stat">
              <span className="reservation-schedule-stat__label">Departure</span>
              <span className="reservation-schedule-stat__value">{reservation.departure}</span>
            </div>
            <div className="reservation-schedule-stat">
              <span className="reservation-schedule-stat__label">Efficiency</span>
              <span className="reservation-schedule-stat__value">
                {reservation.efficiency}%
              </span>
              <Progress
                className="progress-xs"
                color={
                  reservation.efficiency <= 25
                    ? "danger"
                    : reservation.efficiency <= 50
                    ? "warning"
                    : reservation.efficiency <= 90
                    ? "orange"
                    : reservation.efficiency > 90 &&
                      reservation.efficiency <= 100
                    ? "success"
                    : "#00000"
                }
                value={reservation.efficiency}
              />
            </div>
          </div>
        </div>

        <div className="reservation-schedule-toolbar">
          <div className="reservation-schedule-toolbar__actions">
            <ButtonGroup>
              <Button
                onClick={() => {
                  this.saveReservationSchedule();
                }}
                color={"faiz1"}
                disabled={savingReservationSchedule}
              >
                {savingReservationSchedule ? (
                  <>
                    <Spinner size={10} animating={true} color={"#fff"} />{" "}
                  </>
                ) : null}
                <i className={"fa fa-floppy-o"} /> Save
              </Button>
            </ButtonGroup>
          </div>

          <div className="reservation-schedule-toolbar__meta">
            <div className="reservation-schedule-toolbar__toggle">
              Edit Previous Days
              <AppSwitch
                className={"mx-1"}
                variant={"pill"}
                color={"faiz1"}
                onChange={(e) => {
                  let value = false;
                  e.target.checked ? (value = true) : (value = false);
                  this.props.updateReservationProps([
                    { prop: "isOldDaysEnabled", value },
                  ]);
                }}
                checked={isOldDaysEnabled}
              />
            </div>
            <ZoomComponent
              zoom={zoom}
              prop={"zoom"}
              updateMethod={this.props.updateReservationProps.bind(this)}
            />
          </div>
        </div>

        <div className="reservation-schedule-card">
          <div className="reservation-schedule-card__header">
            <div>
              <h2 className="reservation-schedule-card__title">Daily Visit Board</h2>
              <p className="reservation-schedule-card__copy">
                Drag visits to reorder them, add missing venues, and adjust times
                directly inside each schedule card.
              </p>
            </div>
            {notCovered.length > 0 ? (
              <div className="reservation-schedule-not-covered">
                {notCovered.map((place) => {
                  return (
                    <div
                      className="reservation-schedule-not-covered__item"
                      key={place.id || place.name}
                    >
                      <i
                        className="fa fa-times-circle"
                        size={10}
                        style={{ color: "red" }}
                      />
                      <span>{place.name}</span>
                    </div>
                  );
                })}
              </div>
            ) : null}
          </div>

          <div className="reservation-schedule-board" style={{ fontSize: zoom }}>
            <Table responsive bordered>
              <thead>
                <tr>
                  {DAYS.map((day) => {
                    return (
                      <th key={day}>
                        <div className="reservation-schedule-board__heading">
                          <b>{day.charAt(0).toUpperCase() + day.slice(1)}</b>
                        </div>
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {calendar.dates.map((week, calWeekIndex) => {
                  return (
                    <tr key={calWeekIndex}>
                      {week.map((day, calDayIndex) => {
                        return (
                          <td key={`${calWeekIndex}-${calDayIndex}`}>
                            {this.renderDay(
                              reservationSchedule,
                              venuesLookup,
                              day,
                              reservation.arrival,
                              reservation.departure,
                              reservation.id,
                              calWeekIndex,
                              calDayIndex,
                              zoom
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ reservationReducer, venuesReducer }) => ({
  reservationReducer,
  venuesReducer,
});

export default connect(mapStateToProps, actions)(ReservationSchedule);
